export default "__VITE_ASSET__Cn8d6Jeq__"